import * as React from 'react';
import * as Moment from 'moment';
import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import de from 'date-fns/locale/de';
import * as classNames from 'classnames';
import 'react-datepicker/dist/react-datepicker.css';
import './style/WDatepicker.css';
import style from './style/WDatepicker.less';

registerLocale('de', de);

interface WDatepickerProps extends React.ClassAttributes<any> {
    mode: string;
    forcePlausibel?: boolean;
    stampVon?: number;
    stampBis?: number;
    minDate?: number;
    maxDate?: number;
    extendedOptions?: boolean;
    onlyExtendedOptions?: boolean;
    style?: any;
    onChange(stamp: any): void;
}

interface WDatepickerState {
    stampVon: number;
    stampBis: number;
    valExtendedOptions: string;
}

export class WDatepicker extends React.Component<WDatepickerProps, WDatepickerState> {
    constructor(props: any) {
        super(props);

        this.rendDatePicker = this.rendDatePicker.bind(this);
        this.onChangeExtendedOptions = this.onChangeExtendedOptions.bind(this);
        this.onChangeDatePickerVon = this.onChangeDatePickerVon.bind(this);
        this.onChangeDatePickerBis = this.onChangeDatePickerBis.bind(this);
        this.onChangeCallBack = this.onChangeCallBack.bind(this);
        this.checkPlausibel = this.checkPlausibel.bind(this);

        this.state = {
            stampVon: null,
            stampBis: null,
            valExtendedOptions: ''
        };
    }

    componentDidMount(): void {
        this.setStamp();
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.stampVon !== this.props.stampVon || prevProps.stampBis !== this.props.stampBis) {
            this.setStamp();
        }
    }

    setStamp() {
        let startValVon, startValBis;
        if (!this.props.stampVon && !this.props.stampBis) {
            startValVon = Moment().startOf('year').unix();
            startValBis = Moment().endOf('year').unix();
        } else {
            if (this.props.stampVon > 0) {
                startValVon = this.props.stampVon;
            }
            if (this.props.stampBis > 0) {
                startValBis = this.props.stampBis;
            }
            if (this.props.mode === 'range' && startValVon > 0 && this.props.forcePlausibel && startValBis <= startValVon) {
                startValBis = startValVon + 24 * 60 * 60 - 1;
            }
        }
        this.setState({
            stampVon: startValVon,
            stampBis: startValBis
        });
    }

    render() {
        return this.rendDatePicker();
    }

    rendDatePicker() {
        const dpv = <DatePicker
            name='date'
            className={classNames(style.DatePicker, (this.props.style ? this.props.style.DatePicker : ''))}
            selected={Moment.unix(this.state.stampVon).toDate()}
            onChange={this.onChangeDatePickerVon}
            locale='de'
            showMonthDropdown
            useShortMonthInDropdown
            showYearDropdown
            dropdownMode='scroll'
            timeFormat='HH:mm:ss'
            dateFormat='dd.MM.yyyy'
            minDate={this.props.minDate ? Moment(new Date(this.props.minDate * 1000)).toDate() : Moment(new Date(1971, 0, 1)).toDate()}
            maxDate={this.props.maxDate ? Moment(new Date(this.props.maxDate * 1000)).toDate() : Moment(new Date(2037, 11, 31)).toDate()}
            todayButton='Heute'
        />;

        const dpb = <DatePicker
            name='date'
            className={classNames(style.DatePicker, (this.props.style ? this.props.style.DatePicker : ''))}
            selected={Moment.unix(this.state.stampBis).toDate()}
            onChange={this.onChangeDatePickerBis}
            locale='de'
            showMonthDropdown
            useShortMonthInDropdown
            showYearDropdown
            dropdownMode='scroll'
            timeFormat='HH:mm:ss'
            dateFormat='dd.MM.yyyy'
            minDate={this.props.minDate ? Moment(new Date(this.props.minDate * 1000)).toDate() : Moment(new Date(1971, 0, 1)).toDate()}
            maxDate={this.props.maxDate ? Moment(new Date(this.props.maxDate * 1000)).toDate() : Moment(new Date(2037, 11, 31)).toDate()}
            todayButton='Heute'
        />;

        let wdp: JSX.Element = null;
        if (this.props.mode === 'range') {
            wdp =
                <div>
                    <div>
                        <div className={classNames(style.div, (this.props.style ? this.props.style.von_bis : ''))}>von:</div>
                        <div className={style.div}>{dpv}</div>
                    </div>
                    <div>
                        <div className={classNames(style.div, (this.props.style ? this.props.style.von_bis : ''))}>bis:</div>
                        <div className={style.div}>{dpb}</div>
                    </div>
                </div>;
        } else {
            // this.props.mode === 'single'
            wdp =
                <div>
                    <div className={style.div}>
                        {dpv}
                    </div>
                </div>;
        }

        let exop: JSX.Element = null;
        if (this.props.extendedOptions) {
            exop =
                <select
                    className={style.exop}
                    onChange={this.onChangeExtendedOptions}
                    value={this.state.valExtendedOptions}
                >
                    <option value=''>-</option>
                    <option value='lw'>Letzte Woche</option>
                    <option value='lm'>Letzten Monat</option>
                    <option value='lj'>Letztes Jahr</option>
                    <option value='dw'>Diese Woche</option>
                    <option value='dm'>Dieser Monat</option>
                    <option value='dj'>Dieses Jahr</option>
                </select>;
        }

        return (
            <div
                className={classNames('WDatePicker', (this.props.style ? this.props.style.WDatepickerCustomer : ''))}
            >
                {!this.props.onlyExtendedOptions && wdp}
                {exop}
            </div>
        );
    }

    onChangeExtendedOptions(event: any) {
        const valExtendedOptions = event.target.value;
        const y = new Date().getFullYear();
        const m = new Date().getMonth();
        const stamp = new Date().getTime();
        let stampVon = this.state.stampVon;
        let stampBis = this.state.stampBis;
        let wk: any;

        switch (valExtendedOptions) {
            case 'lw':
                wk = this.getWeek(stamp - 7 * 24 * 60 * 60 * 1000);
                stampVon = wk[0].getTime() / 1000;
                stampBis = wk[1].getTime() / 1000;
                break;
            case 'lm':
                stampVon = new Date(y, m - 1, 1).getTime() / 1000;
                stampBis = new Date(y, m, 0).getTime() / 1000;
                break;
            case 'lj':
                stampVon = new Date(y - 1, 0, 1).getTime() / 1000;
                stampBis = new Date(y - 1, 11, 31).getTime() / 1000;
                break;
            case 'dw':
                wk = this.getWeek(stamp);
                stampVon = wk[0].getTime() / 1000;
                stampBis = wk[1].getTime() / 1000;
                break;
            case 'dm':
                stampVon = new Date(y, m, 1).getTime() / 1000;
                stampBis = new Date(y, m + 1, 0).getTime() / 1000;
                break;
            case 'dj':
                stampVon = new Date(y, 0, 1).getTime() / 1000;
                stampBis = new Date(y, 11, 31).getTime() / 1000;
                break;
            default:
                stampVon = this.props.stampVon >= 0 ? this.props.stampVon : 0;
                stampBis = this.props.stampBis >= 0 ? this.props.stampBis : new Date().getTime() / 1000;
        }

        this.setState({ stampVon, stampBis, valExtendedOptions }, this.onChangeCallBack);
    }

    getWeek(stamp: number) {
        const d = new Date(stamp);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        const day = d.getDay();
        const diff = d.getDate() - day + (day === 0 ? -6 : 1);
        return [
            new Date(d.setDate(diff)),
            new Date(d.setDate(diff + 6))
        ];
    }

    onChangeDatePickerVon(date: any) {
        const stampVon = new Date(date).getTime() / 1000;
        const valExtendedOptions = '';
        if (this.props.forcePlausibel && !this.checkPlausibel(stampVon, this.state.stampBis)) {
            return;
        }
        this.setState({ stampVon, valExtendedOptions }, this.onChangeCallBack);
    }

    onChangeDatePickerBis(date: any) {
        const stampBis = new Date(date).getTime() / 1000;
        const valExtendedOptions = '';
        if (this.props.forcePlausibel && !this.checkPlausibel(this.state.stampVon, stampBis)) {
            return;
        }
        this.setState({ stampBis, valExtendedOptions }, this.onChangeCallBack);
    }

    onChangeCallBack() {
        const von = this.state.stampVon;
        const bis = this.state.stampBis;
        if (this.props.mode === 'range') {
            this.props.onChange({ von, bis });
        } else {
            this.props.onChange({ von });
        }
    }

    checkPlausibel(von: number, bis: number) {
        if (von > 0 && bis > 0 && von > bis) {
            alert('Das Datum "bis" muss später als das Datum "von" sein.');
            // return false;
        }
        return true;
    }

}
